import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getInitials } from '../../utils';
import s from './style.css';
import SettingsMenu from './SettingsMenu';
import { app } from '../../actions';
const ProfileMenu = (props) => {
    const [retried, setRetried] = useState(false);
    const { visible, setVisible } = props;
    const profilePicture = props.user ? props.user.profilePicture : null;
    useEffect(() => {
        if (profilePicture && !props.uri) {
            props.cacheProfilePicture(profilePicture);
        }
    }, []);
    useEffect(() => {
        setVisible(false);
    }, [props.cancelMenus]);
    const handleError = () => {
        if (retried)
            return;
        setRetried(true);
        props.cacheProfilePicture(profilePicture);
    };
    if (!props.user)
        return React.createElement("div", null);
    return (React.createElement("div", { className: s.container },
        React.createElement("button", { type: 'button', className: s.circle, onClick: (e) => {
                e.stopPropagation();
                setVisible(!visible);
            } },
            profilePicture && props.uri ? (React.createElement("img", { src: props.uri, className: s.imageFile, onError: handleError })) : (React.createElement("p", { className: s.name }, getInitials(props.user.name))),
            React.createElement(SettingsMenu, { visible: visible, setVisible: setVisible }))));
};
const mapStateToProps = (state) => ({
    user: state.auth.user,
    isBasic: !state.auth.user || state.auth.user.subscription === 'basic',
    cancelMenus: state.appTemp.cancelMenus,
    uri: state.app.profilePictureUri,
});
const connector = connect(mapStateToProps, { ...app });
export default connector(ProfileMenu);
